import { Component, OnInit } from '@angular/core';
import { KnittingMachine } from '../../../models/knitting/knitting';
import { UserFull } from '../../../models/user-master/user-lite';
import { KnittingMachineProxyService } from '../../../proxies/production/knitting-machines.proxy.service';
import { UsersProxyService } from '../../../proxies/users.proxy.service';

@Component({
  selector: 'app-machines-assignment',
  templateUrl: './machines-assignment.component.html',
  styleUrl: './machines-assignment.component.scss',
})
export class MachinesAssignmentComponent implements OnInit {
  isLoading = 0;

  knittingMachines: KnittingMachine[] = [];
  operatorsList: UserFull[] = [];
  draggedOperator: UserFull | null = null;

  constructor(
    private knittingMachineProxyService: KnittingMachineProxyService,
    private usersProxyService: UsersProxyService,
  ) {}

  ngOnInit(): void {
    this.getAllMachines();
    this.getUsers();
  }

  getUsers() {
    this.usersProxyService.getAllUsers().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.operatorsList = response.data;
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  getAllMachines() {
    // this.knittingMachineProxyService.searchMachineDetail({}).subscribe({
    //   next: (machines) => {
    //     this.knittingMachines = machines;
    //   },
    //   error: (error) => {
    //     console.error(error);
    //   },
    // });
  }

  shiftChange() {
    this.knittingMachineProxyService.shiftMachines().subscribe({
      next: (machines) => {
        this.knittingMachines = machines;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  updateKnittingMachine(knittingMachine: KnittingMachine) {
    this.knittingMachineProxyService.updateKnittingMachine(knittingMachine).subscribe({
      next: () => {
        this.getAllMachines();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  removeMachineOperator(machineIndex: number, operatorName: string | null) {
    this.knittingMachines[machineIndex].currentOperatorUserName = operatorName;
    this.updateKnittingMachine(this.knittingMachines[machineIndex]);
  }

  dragStart(operator: UserFull) {
    this.draggedOperator = operator;
  }

  drop(machineIndex: number) {
    if (this.draggedOperator) {
      this.removeMachineOperator(machineIndex, `${this.draggedOperator.profile.firstName} ${this.draggedOperator.profile.lastName}`);
      this.draggedOperator = null;
    }
  }

  dragEnd() {
    this.draggedOperator = null;
  }

  findIndex(operator: UserFull) {
    let index = -1;
    for (let i = 0; i < this.operatorsList.length; i++) {
      if (operator.id === this.operatorsList[i].id) {
        index = i;
        break;
      }
    }
    return index;
  }
}
